<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-6">
                    <h3 class="text-uppercase">{{ $t('cohorts.outdated') }}</h3>
                    <small class="text-muted">{{ $t('cohorts.outdated-meaning', { age: dataConservation }) }}</small>
                </div>
                <div class="col-6 text-right">
                    <base-button type="danger" size="sm" @click="deleteAll()">
                        <span class="btn-inner--icon"><i class="tim-icons icon-simple-remove"></i></span>
                        <span class="btn-inner--text">{{ $t('common.delete-all') }}</span>
                    </base-button>
                </div>
            </div>
        </div>

        <p class="card-body pt-0 text-sm" v-if="empty">{{ $t('cohorts.no-cohort') }}</p>

        <div class="pt-2" v-if="!empty">
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    header-row-class-name="thead-light"
                    :data="ctrl.rows">

                <el-table-column :label="$t('common.name')">
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            <a href="#" @click.prevent="openLearners(row)">
                                {{ row.name }}
                            </a>
                        </h4>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.creation')">
                    <template v-slot="{row}">
                        <small>
                            {{ creationDate(row) }}
                        </small>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.owner')">
                    <template v-slot="{row}">
                        {{ owners[row.owner_id] }}
                    </template>
                </el-table-column>

                <el-table-column :label="$t('cohorts.members')">
                    <template v-slot="{row}">
                        <a href="#" @click.prevent="openLearners(row)">
                            <small>
                                {{ $t('common.learners') }}: {{ row.learners_count }}
                            </small>
                        </a>
                        <br>
                        <a href="#" @click.prevent="openInstructors(row)">
                            <small>
                                {{ $t('common.instructors') }}: {{ row.instructors_count }}
                            </small>
                        </a>
                    </template>
                </el-table-column>

                <el-table-column align="right" width="60" class-name="actions">
                    <template v-slot="{row}">
                        <a href="#" class="table-action text-danger" @click.prevent="ctrl.delete(row.id)">
                            <i class="tim-icons icon-simple-remove"></i>
                        </a>
                    </template>
                </el-table-column>

            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <portal to="modals">

            <confirm-modal v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('cohorts.delete-confirm') }}</p>
            </confirm-modal>

            <confirm-modal v-model="ctrl.modals.confirmDeleteAll">
                <p>{{ $t('cohorts.delete-all-confirm') }}</p>
            </confirm-modal>

        </portal>

    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import CohortMapping from './CohortMapping'
    import moment from 'moment'

    export default {

        data() {
            let mapping = new CohortMapping()
            return {
                loaded: false,
                mapping,
                ctrl: new CrudController({
                    endpoint: '/socrates/api/front/cohorts',
                    mapData: mapping.mapData,
                    unmapData: mapping.unmapData,
                    modals: ['confirmDeleteAll'],
                    paging: {
                        perPage: 10,
                        perPageOptions: [5, 10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: ['-created_at', 'name'],
                        include: ['owners'],
                        accessors: ['learners_count', 'instructors_count'],
                        filters: { outdated: true },
                    },
                    errors: {
                        '423-delete': 'cohorts.423-delete',
                    }
                }),
                search: '',
                owners: {},
                moment: moment,
                next: false
            }
        },

        computed: {

            dataConservation() {
                return this.$auth['config'].data_conservation
            },

            empty() {
                return this.ctrl.rows.length == 0 && !this.search
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.owners = Array.isArray(resp.data.included.owners) ? {} : resp.data.included.owners
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({ name: {$text: val} })
            }
        },

        methods: {

            deleteAll() {
                this.ctrl.modals.open('confirmDeleteAll').then(confirmResponse => {
                    if (confirmResponse.confirmed) {
                        this.$loader.show()
                        axios.delete(
                            '/socrates/api/front/cohorts',
                            { params: { filters: { outdated: true } }}
                        )
                        .then(response => {
                            this.ctrl.list()
                            this.$loader.hide()
                        }).catch(error => {
                            this.ctrl.list()
                            this.$loader.hide()
                            //this.$auth.handleErrorVm(error, this)
                        })
                    }
                })
            },

            creationDate(row) {
                return this.moment(row.created_at).format('YYYY/MM/DD')
            },
            
            openLearners(row) {
                this.$router.push({ name: 'admin-cohort', params: { id: row.id, role: 'learner' } })
            },

            openInstructors(row) {
                this.$router.push({ name: 'admin-cohort', params: { id: row.id, role: 'instructor' } })
            },
        }
    }
</script>

<style scoped>

    .card >>> .el-table .cell {
        line-height: 1.5;
    }
    .card >>> td {
        padding-right: 0;
    }
    .card >>> td.actions {
        padding-left: 0;
        padding-right: 1.5rem;
    }

</style>